import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./InComeTable.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { separate } from "../../../Utils/SeprateNumber/SeprateThreeNumber";
import { JalaliDate } from "../../../Utils/JalaliDate/JalaliDate";
// import {PencilSquare, XLg } from "react-bootstrap-icons";

const InComeTable = ({ openModal, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  // let dataSource = [];
  // let index = 1;
  // data &&
  //   data.forEach((element) => {
  //       dataSource.push({
  //           key: index,
  //           id:element.id,
  //           pName:element.brand_persian,
  //           eName: element.brand_english
  //         });
  //     index = index + 1;
  //   });
  const columns = [
    {
      title: "پیگیری تراکنش",
      dataIndex: "trackId",
      key: "trackId",
      width: "8%",
      ...getColumnSearchProps("trackId", "پیگیری تراکنش "),

    },
    {
      title: "مقدار",
      dataIndex: "idpayAmount",
      key: "idpayAmount",
      width: "8%",
      ...getColumnSearchProps("idpayAmount", "مقدار"),
    },
    {
      title: "شماره کارت",
      dataIndex: "idpayCardNo",
      key: "idpayCardNo",
      width: "8%",
      ...getColumnSearchProps("idpayCardNo", "شماره کارت"),
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      width: "8%",
      ...getColumnSearchProps("date", "تاریخ"),
      render:(text,record)=>(
        <p>{JalaliDate(record.date)}</p>
      )
    },

    {
      title: "شماره کارت هش شده",
      dataIndex: "idpayHashedCardNo",
      key: "idpayHashedCardNo",
      width: "8%",
      ...getColumnSearchProps("idpayHashedCardNo", "شماره کارت هش شده"),
    },

    // {
    //   title: "ایدی ایدی پی",
    //   dataIndex: "idpay_id",
    //   key: "idpay_id",
    //   width: "8%",
    //   ...getColumnSearchProps("idpay_id", "ایدی ایدی پی"),
    // },

    {
      title: "کارمزد ایدی پی",
      dataIndex: "idpayPaymentAmount",
      key: "idpayPaymentAmount",
      width: "8%",
      ...getColumnSearchProps("idpayPaymentAmount", "کارمزد ایدی پی"),
      render:(text,record)=>(
        <p>{separate(text)}ریال</p>
      )
    },

    {
      title: "تاریخ پرداخت",
      dataIndex: "idpayPaymentDate",
      key: "idpayPaymentDate",
      width: "8%",
      ...getColumnSearchProps("idpayPaymentDate", "تاریخ پرداخت"),
    },

    {
      title: "آیدی پیگیری پرداخت",
      dataIndex: "idpayPaymentTrackId",
      key: "idpayPaymentTrackId",
      width: "8%",
      ...getColumnSearchProps("idpayPaymentTrackId", "آیدی پیگیری پرداخت"),
    },

    {
      title: "وضعیت",
      dataIndex: "idpayStatus",
      key: "idpayStatus",
      width: "8%",
      ...getColumnSearchProps("idpayStatus", "وضعیت"),
    },

    {
      title: "پیگیری آیدی پی",
      dataIndex: "idpayTrackId",
      key: "idpayTrackId",
      width: "8%",
      ...getColumnSearchProps("idpayTrackId", "پیگیری آیدی پی"),
    },

    {
      title: "تاریخ تاییدیه",
      dataIndex: "idpayVerifyDate",
      key: "idpayVerifyDate",
      width: "8%",
      ...getColumnSearchProps("idpayVerifyDate", "تاریخ تاییدیه"),
    },

    {
      title: "آیدی سفارش",
      dataIndex: "orderId",
      key: "orderId",
      width: "8%",
      ...getColumnSearchProps("orderId", "آیدی سفارش"),
    },
    // {
    //   title: "عملیات",
    //   dataIndex: "action",
    //   key: "action",
    //   width: "8%",
    //   render: (text, record) => (
    //     <div className={Style.btnHolder}>
    //       <button
    //         onClick={() => openModal(1, record)}
    //         className={Style.editBtn}
    //       >
    //         <PencilSquare />
    //       </button>
    //       <button
    //           onClick={() => openModal(2, record)}
    //           className={Style.deleteBtn}
    //         >
    //           <XLg />
    //         </button>
    //     </div>
    //   ),
    // },
  ];
  return (
    <div style={{ width: "100%" }} className={Style.TabelHolder}>
      <Table
        pagination={{ pageSize: 8 }}
        columns={columns}
        dataSource={data}
        loading={data === undefined ? true : false}
        scroll={{x:1500, y: 450 }}
      />
    </div>
  );
};

export default InComeTable;
